import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import RouteLink from '../navigation/RouteLink';

export default function DestinationRoutes({
	destination,
	routes,
	namespace = 'departures',
}) {
	const { t } = useTranslation(['destination', 'common']);

	return (
		<div className="py-8">
			<div className="xl:grid xl:grid-cols-3 xl:gap-x-8">
				<div>
					<span className="text-lg font-semibold text-blue-600">
						{t(`destination:${namespace}.overtitle`)}
					</span>
					<h2 className="mt-2 text-3xl font-bold tracking-tight text-gray-900">
						{t(`destination:${namespace}.title`, {
							destination: destination.shortName,
						})}
					</h2>
					<p className="mt-4 text-base text-gray-500">
						{t(`destination:${namespace}.description`, {
							destination: destination.shortName,
						})}
					</p>
				</div>
				<div className="mt-4 sm:mt-8 md:mt-10 md:grid md:grid-cols-2 md:gap-x-4 lg:pt-2 xl:col-span-2 xl:mt-0">
					<ul role="list" className="divide-y divide-gray-200">
						{routes.slice(0, 5).map((route, featureIdx) => (
							<li
								key={route.id}
								className={clsx(
									featureIdx === 0 ? 'md:py-0 md:pb-4' : '',
									'py-4'
								)}
							>
								<h3>
									<RouteLink
										prefetch={false}
										transportType={destination.transport_type}
										route={route}
										className="ml-3 flex items-center text-base text-blue-600 hover:text-blue-700"
									/>
								</h3>
							</li>
						))}
					</ul>
					<ul
						role="list"
						className="divide-y divide-gray-200 border-t border-gray-200 md:border-t-0"
					>
						{routes.slice(5, 10).map((route, featureIdx) => (
							<li
								key={route.id}
								className={clsx(
									featureIdx === 0 ? 'md:border-t-0 md:py-0 md:pb-4' : '',
									'py-4'
								)}
							>
								<h3>
									<RouteLink
										prefetch={false}
										route={route}
										transportType={destination.transport_type}
										className="ml-3 flex items-center text-base text-blue-600 hover:text-blue-700"
									/>
								</h3>
							</li>
						))}
					</ul>
				</div>
			</div>
		</div>
	);
}
